import { logger } from '@sentry/utils';
import { saveSession } from './saveSession.js';
import { getSessionSampleType, makeSession } from './Session.js';
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */

function createSession(_ref) {
  var sessionSampleRate = _ref.sessionSampleRate,
      errorSampleRate = _ref.errorSampleRate,
      _ref$stickySession = _ref.stickySession,
      stickySession = _ref$stickySession === void 0 ? false : _ref$stickySession;
  var sampled = getSessionSampleType(sessionSampleRate, errorSampleRate);
  var session = makeSession({
    sampled: sampled
  });
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log("[Replay] Creating new session: ".concat(session.id));

  if (stickySession) {
    saveSession(session);
  }

  return session;
}

export { createSession };